export class NextWorkout {
    public uniqueReference: string;
    constructor(public id: string,
                public earliestAllowedStartTime: string,
                public startTimeOfFirstExercise: string,
                public workoutType: number,
                public cardioOrResistance: string,
                public threeBodyGroups: string[],
                public level: string,
                public gymName: string,
                public startTime: string) {
                    this.uniqueReference = id;
                }
}
